<template lang="pug">
  v-row
    v-col(
      cols=12 lg=8
    )
      v-card(color="grey lighten-4" flat).sdo-radius.pa-3
        v-card-text
          // Заголовок
          v-slide-x-transition(leave-absolute)
            v-skeleton-loader.mt-2(
              type="heading"
              v-if="!course.title"
              transition="slide-x-transition"
            )
            v-row(v-else).ma-0.pa-0.align-center
              h1.text-h5.mb-4: strong {{ course.title }}

          // Описание
          v-slide-x-reverse-transition(leave-absolute)
            v-skeleton-loader.mt-4(
              type="text"
              v-if="!course.description"
              transition="slide-x-reverse-transition"
            )
            p(v-else class="grey--text") {{ course.description }}

          v-row
            v-col.grow
              task-menu(
                v-if="course.tasks"
                :tasks="course.tasks"
                outlined
                color="primary"
                unit-model="courses"
                :unit-id="course.id"
                @task:detach="course.tasks = $event"
                @task:attach="course.tasks.push($event)"
              )
            v-col.shrink
              v-btn(
                outlined
                text
                :to="{ name: 'CourseEnrollment' }"
              ) Перейти к наборам

      v-sheet.mt-10
        unit-management(
          v-if="course.id"
          ref="unitManagement"
          :course="course"
          :editable="course.can_edit"
          :method="getCourseUnits"
          @removed:module="fetchModules"
        )

    v-scroll-y-transition
      v-col(cols=12 lg=4)(v-if="filteredModules.length")
        v-card(color="secondary" dark).sdo-card
          v-card-text
            v-alert(color="secondary lighten-1").ma-3
              p
                v-icon.mr-2 mdi-information
                strong Доступно: {{ $tc('modules', filteredModules.length) }}
              span  Для того чтобы добавить модуль в курс,
                |  выберите необходимый из списка ниже и нажмите кнопку "Добавить"
            v-divider.mt-4
            select-list-module(
              v-model="modules.selected"
              :items="filteredModules"
              :loading="modules.loading"
            )
            v-expand-transition
              v-btn.mb-3(
                v-if="modules.selected"
                depressed
                block
                large
                light
                :loading="attach.loading"
                @click="attachModule"
              ) Добавить
</template>

<script>
import UnitManagement from '@/components/Unit/UnitManagement.vue';
import TaskMenu from '@/components/Unit/UnitManagementTaskMenu.vue';
import SelectListModule from '@/components/InputFields/course-module/SelectListModule.vue';

export default {
  name: 'CourseUnitList',
  components: {
    TaskMenu,
    UnitManagement,
    SelectListModule,
  },
  data: () => ({
    modules: {
      selected: null,
      items: [],
      loading: false,
    },
    course: {},

    attach: {
      loading: false,
    },
    loading: false,
  }),
  computed: {
    filteredModules() {
      return this.modules.items.filter((i) => !i.courses.find((c) => c.id === this.course.id));
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      await Promise.all([
        this.fetchCourse(),
        this.fetchModules(),
      ]);
      this.loading = false;
    },
    async fetchCourse() {
      const courseParams = {
        expand: 'edit,tasks,prior_records',
      };
      const { item } = await this.$api.courses.show(this.$route.params.id, courseParams);
      this.course = item;
    },
    getCourseUnits() {
      return this.$api.courseUnits.index({
        'search[course_id]': this.course.id,
        expand: 'lessons,course_modules,tasks',
      });
    },
    async fetchModules() {
      this.modules.loading = true;
      const { items } = await this.$api.modules.index({
        'search[user_id]': this.$user.data.id,
        expand: 'course_units_count,accepted_users_count,courses',
      });
      this.modules.items = items;
      this.modules.loading = false;
    },
    async attachModule() {
      this.attach.loading = true;
      await this.modules.selected.attach(this.course.id);
      this.$refs.unitManagement.init();
      this.fetchModules();
      this.attach.loading = false;
    },
  },
};
</script>
